module.exports = __webpack_public_path__ + "img/70SPOLVERINO-COUVE-U-RIC.GRECIA-RIC.LIMONESHORT-LINDO-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.3ec74038.jpg";